/**
 * Get the cell value for the Estimated Loss cell. Note that this cell works differently than
 * Detections, Gap, or Performances; whenever updateTrqkGapChannelSelections is called, the
 * estimated_loss_max and estimated_loss_min are updated on the channel. This means we don't need to
 * source the cell value from a different field in the data in the two states of audiosIncluded (
 * true vs. false).
 * @param gapChannel
 * @returns
 */
export const getGapChannelEstimatedLossCellValue = (
    gapChannel: TrqkGapChannel,
): GapChannelEstimatedLossCellValue => {
    const { estimated_loss_max, estimated_loss_min } = gapChannel;

    return {
        estimatedLossMax: estimated_loss_max ?? 0,
        estimatedLossMin: estimated_loss_min ?? 0,
    };
};
